import { useState } from "react";
import SignUpStep1 from "./SignUpStep1";
import SignUpStep2 from "./SignUpStep2";
import SignUpStep3 from "./SignUpStep3";

const SignUp = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [userData, setUserData] = useState({
        name: '',
        email: '',
        password: '',
        password2: '',
        ordId: '',
        countryCode: '',
        region: '',
        grouptype: [],
        groupId: '',
        type: [],
        termpol: [

        ]
    });

    const [officeData, setOfficeData] = useState({
        type: 'CREATE',
        grouptype: [],
        countryCode: '',
        name: '',
        address: '',
        zipcode: '',
        tel: '',
        coords: [],
        region: ''
    });

    const [htmlContents, setHtmlContents] = useState({ terms: '', poilicy: '' });

    return (
        <>
            {
                currentStep === 1 &&
                <SignUpStep1
                    userData={userData}
                    setUserData={(data) => setUserData(data)}
                    officeData={officeData}   
                    htmlContents={htmlContents}                 
                    setHtmlContents={(data) => setHtmlContents(data)}
                    goNextStep={() => setCurrentStep(2)} />
            }
            
            {
                currentStep === 2 &&
                <SignUpStep2
                    userData={userData}                    
                    officeData={officeData}
                    setOfficeData={(data) => setOfficeData(data)}
                    htmlContents={htmlContents}
                    goPrevStep={() => setCurrentStep(1)} 
                    goNextStep={() => setCurrentStep(3)}
                    />
            }

            {
                currentStep === 3 &&
                <SignUpStep3 />
            }
        </>
    )
}

export default SignUp;